export default {
    add_patient: "Bemor qo‘shish",
    add_task: "Topshiriq qo‘shish",
    calls: "Qo‘ng‘iroqlar",
    chat_panel: "Chat panel",
    clinic_id: "Id klinikalar",
    confirm: "Tasdiqlang",
    expenses: "Xarajatlar",
    high: "Yuqori",
    low: "Past",
    medium: "O‘rta",
    no_notifications: "Bildirishnomalar yo‘q",
    read_all: "Barchasini o‘qish",
    remove_confirmation: "Tasdiqlashni bekor qilish",
    tasks: "Topshiriqlar"
}
